/* Psolys · product page: gallery views and the sticky buy bar. */
(() => {
  const { $, $$ } = window.psolys;

  /* gallery: Lou's product photos, one thumbnail each */
  const gallery = $('[data-gallery]');
  if (gallery) {
    const label = $('[data-photo-label]');
    $$('input[name="photo"]').forEach(r => r.addEventListener('change', () => {
      $$('img[data-photo]', gallery).forEach(img => img.classList.toggle('is-on', img.dataset.photo === r.value));
      if (label) label.textContent = r.dataset.label;
    }));
  }

  /* buy bar: visible once the hero and the buy panel have scrolled away */
  const bar = $('[data-buybar]');
  if (bar && 'IntersectionObserver' in window) {
    const seen = new Map();
    const set = () => {
      const on = [...seen.values()].every(v => !v);
      bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', String(!on));
      $$('button, a', bar).forEach(el => el.tabIndex = on ? 0 : -1);
    };
    const io = new IntersectionObserver(es => { es.forEach(e => seen.set(e.target, e.isIntersecting)); set(); });
    $$('[data-buybar-hide]').forEach(el => { seen.set(el, true); io.observe(el); });
    const foot = $('.footer'); if (foot) { seen.set(foot, false); io.observe(foot); }
  }
})();
